<template>

    <form @submit.prevent="armazenar">

        <div class="row">
            <vc-mostra-mensagem-validacao></vc-mostra-mensagem-validacao>

            <div class="col-xs-12 col-sm-4" :class="{ 'col-sm-4' : cultura.tipo === 'SOLO'}">
                <div class="form-group">
                    <label>Tipo</label>
                    <v-select
                            :disabled="modo === 'editar'"
                            v-model="cultura.tipo"
                            :options="[
                                {label: 'Solo', value: 'SOLO'},
                                {label: 'Tecido vegetal', value: 'TECIDO'},
                            ]"
                    ></v-select>
                </div>
            </div>

            <div v-if="cultura.tipo.value === 'SOLO'">
                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            v-model="cultura.categoria"
                            label="Categoria"
                            nome-input="categoria_id"
                            :selecionado="cultura.categoria"
                            :selecionado-config="{label : 'descricao', campo : 'id'}"
                            url-busca="api/categoria-cultura/pesquisa"
                            :campos-table="[ {'label' : 'Descrição', 'campo' : 'descricao'}]"
                            obrigatorio="categoria"
                    >
                    </vc-pesquisa>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('nome')}">
                    <label>Nome</label>
                    <input type="text" class="form-control" name="nome" v-model="cultura.nome" v-validate="'required'"/>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-if="cultura.tipo.value === 'TECIDO'">
                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Nitrogênio</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.nitrogenio_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Fósforo</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.fosforo_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Potássio</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.potassio_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Cálcio</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.calcio_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Magnésio</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.magnesio_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Enxofre</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.enxofre_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Zinco</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.zinco_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Manganês</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.manganes_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Boro</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.boro_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Sódio</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.sodio_a_max"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 form-inline">
                    <h3 class="title">Ferro</h3>
                    <div class="row">
                        <div class="col-xs-3">Deficiênte</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_d_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_d_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Normal</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_n_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_n_max"></div>
                    </div>

                    <div class="row">
                        <div class="col-xs-3">Alto</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_a_min"></div>
                        <div class="col-xs-1">à</div>
                        <div class="col-xs-4"><input type="text" class="form-control" v-model="cultura.ferro_a_max"></div>
                    </div>
                </div>
            </div>

            <div v-if="cultura.tipo.value === 'SOLO'">
                <div class="col-xs-12 col-sm-4">
                    <h3 class="title">Nitrogênio</h3>

                    <div class="row">
                        <div class="col-xs-5">Baixo</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.nitrogenio_baixo"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Médio</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.nitrogenio_medio"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Alto</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.nitrogenio_alto"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <h3 class="title">Fósforo</h3>

                    <div class="row">
                        <div class="col-xs-5">Muito baixo</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.fosforo_muito_baixo"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Baixo</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.fosforo_baixo"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Médio</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.fosforo_medio"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Alto</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.fosforo_alto"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Muito alto</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.fosforo_muito_alto"></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <h3 class="title">Potássio</h3>
                    <div class="row">
                        <div class="col-xs-5">Muito baixo</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.potassio_muito_baixo"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Baixo</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.potassio_baixo"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Médio</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.potassio_medio"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Alto</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.potassio_alto"></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Muito alto</div>
                        <div class="col-xs-7"><input type="text" class="form-control" v-model="cultura.potassio_muito_alto"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <br>
                    <label>Observação</label>
                    <textarea cols="30" rows="3" class="form-control" v-model="cultura.observacao"></textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <button type="submit" class="btn btn-success">Salvar</button>
                    &nbsp;
                    <router-link :to="{name: 'culturas'}" class="btn btn-danger">Cancelar</router-link>
                </div>
            </div>
        </div>
    </form>

</template>

<script>
    import VcPesquisa from '@/components/Form/Pesquisa'
    import VcMostraMensagemValidacao from '@/components/Form/MostraMensagemValidacao'

    export default {
        components: {
            VcPesquisa,
            VcMostraMensagemValidacao
        },
        data() {
            return {
                modo: null,
                cultura: {
                    tipo: {label: 'Solo', value: 'SOLO'},
                }
            }
        },

        methods: {
            armazenar() {

                this.$validator.validate().then(valid => {
                    if (!valid) {
                        return null;
                    }

                    let cultura = this.cultura;

                    cultura.tipo = cultura.tipo.value

                    if (cultura.categoria != null) {
                        cultura.categoria_id = cultura.categoria.id;
                    }

                    let controlePromise = (promise) => {
                        promise.then(() => {
                            window.swal("Sucesso", "Cultura armazenada com sucesso!", "success");
                            this.$router.push({name: 'culturas'});
                        }).catch(
                            error => window.swal("Atenção", "Houve um problema ao armazenar a cultura.  <br><br>" + error.response.data.message, "warning")
                        );
                    };

                    if (this.modo === 'editar') {
                        controlePromise(this.$http.put('api/culturas/' + cultura.id, cultura))
                    } else {
                        controlePromise(this.$http.post('api/culturas', cultura))
                    }
                })
            }
        },

        async mounted() {

            if (this.$route.name == 'culturas.editar') {
                
                let model = {}

                await this.$http.get(`api/culturas/${this.$route.params.id}`)
                    .then((response) => model = response.data)
                    .catch(error => {throw Error(error)})

                model.tipo = {
                    label: (model.tipo.charAt(0) + model.tipo.slice(1).toLowerCase()),
                    value: model.tipo
                }

                this.$set(this, 'cultura', model)
                this.$set(this, 'modo', 'editar')
                this.$store.dispatch('removeEditingModel')
            } else {
                        this.$set(this, 'modo', 'adicionar');
            }

            this.$store.dispatch('setTitle', this.modo === 'editar' ? 'Editar cultura' : 'Adicionar cultura')

        }
    }
</script>
